import { Component,EventEmitter,Output,ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';

@Component({
  selector: 'calendar-week',
  templateUrl: './calendar-week.component.html',
})
export class CalendarWeekComponent {
    @ViewChild('calendar') calendar: MatCalendar<Date>;
    @Output() onDateSelectedEvent = new EventEmitter<{fechaInicio:Date, fechaFin:Date}>()
    selectedWeekStart!: Date;
    selectedWeekEnd!: Date;

    onDateSelected(date: Date): void {
        const selectedDate = new Date(date);
        const day = selectedDate.getDay(); // 0 es domingo
        const diffToStart = day === 0 ? -6 :  - day; // Ajusta para que la semana comience en lunes
        const weekStart = new Date(selectedDate);
        weekStart.setDate(selectedDate.getDate() + diffToStart);
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        this.selectedWeekStart = weekStart;
        this.selectedWeekEnd = weekEnd;
        this.calendar.updateTodaysDate();
        this.onDateSelectedEvent.emit( {fechaInicio: weekStart, fechaFin: weekEnd })
    }

    isDateInSelectedWeek(date: Date): boolean {
        if (!this.selectedWeekStart || !this.selectedWeekEnd) {
            return false;
        }
        return date >= this.selectedWeekStart && date <= this.selectedWeekEnd;
    }
    dateClass = (date: Date): string => {
        return this.isDateInSelectedWeek(date) ? 'highlight' : '';
    };

}
